import {TAB_DISABLE, TAB_HIDE} from '../../../common/tabs/tabs.constants';
import {IDS} from './improvement-action-id.constants';

export const tabsState = {
    name: IDS.app_accreditation_scheme_improvement,
    redirectTo: IDS.app_accreditation_scheme_improvement_list,
    url: `/:itemCode/improvement`,
    component: 'tabs',
};

export const ActionsTabState = {
    name: IDS.app_accreditation_scheme_improvement_list,
    url: '/actions',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: TAB_DISABLE,
            id: IDS.app_accreditation_scheme_improvement,
            state: [
                IDS.app_accreditation_scheme_improvement_action,
                IDS.app_accreditation_scheme_improvement_action_plan,
                IDS.app_accreditation_scheme_improvement_step,
            ]
        });
        $ngRedux.dispatch({
            type: TAB_HIDE,
            id: IDS.app_accreditation_scheme_improvement,
            state: [
                IDS.app_accreditation_scheme_improvement_add_action,
            ]
        })
    }
};
ActionsTabState.onEnter.$inject = ['$ngRedux'];

export const actionTabState = {
    name: IDS.app_accreditation_scheme_improvement_action,
    url: `/action?action_id`,
};

export const actionPlanTabState = {
    name: IDS.app_accreditation_scheme_improvement_action_plan,
    url: `/action-plan?action_id`,
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: TAB_DISABLE,
            id: IDS.app_accreditation_scheme_improvement,
            state: [
                IDS.app_accreditation_scheme_improvement_step,
            ]
        })
    }
};
actionPlanTabState.onEnter.$inject = ['$ngRedux'];

export const stepTabState = {
    name: IDS.app_accreditation_scheme_improvement_step,
    url: `/step?action_id&step_id`,
};

export const addActionTabState = {
    name: IDS.app_accreditation_scheme_improvement_add_action,
    url: `/add?hof&slo`,
};